
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33756',
  depVersions: {
  "documents-public-ui": "static-1.33756",
  "client-types": "static-1.442",
  "documents-lib": "static-1.33761",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1823",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4702",
  "highcharts": "static-8.97",
  "hs-promise-utils": "static-1.5295",
  "hs-test-utils": "static-1.7686",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11129",
  "I18n": "static-7.1542",
  "jasmine-immutable": "static-1.2721",
  "jasmine-runner": "static-1.6157",
  "lodash": "static-1.3",
  "quartz": "static-1.6588",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1.16336",
  "reporting-data": "static-1.66117",
  "reporting-testing-lib": "static-1.8050",
  "reporting-visualizations": "static-1.58193",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4450",
  "webpack-env": "static-1.54",
  "atom": "static-1.4777",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2169",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.699",
  "customer-data-filters-ui": "static-1.38548",
  "customer-data-objects": "static-1.7317",
  "customer-data-property-utils": "static-1.7775",
  "data-fetching-client": "static-1.9380",
  "enviro": "static-4.371",
  "FireAlarmUi": "static-1.4240",
  "flux-actions": "static-1.298",
  "FormsCommonComponents": "static-1.85021",
  "FormUrlGenerator": "static-2.4436",
  "foundations-components": "static-1.7320",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11437",
  "icons": "static-2.614",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6848",
  "metrics-js": "static-1.9296",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.334",
  "property-description-translator": "static-1.3564",
  "property-translator": "static-1.5118",
  "quartz-config": "static-1.366",
  "quartz-core": "static-1.5807",
  "quick-fetch": "static-1.3642",
  "raven": "static-3.5564",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5090",
  "react-virtualized": "static-2.92",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7865",
  "reference-resolvers-lite": "static-1.7796",
  "report-customization-components": "static-1.12241",
  "reporting-enablement": "static-1.21768",
  "reporting-reports": "static-1.65795",
  "reporting-snowflake": "static-1.54735",
  "reporting-ui-components": "static-2.63389",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4308",
  "sales-content-partitioning": "static-1.8639",
  "SalesContentIndexUI": "static-3.8751",
  "sanitize": "static-1.4180",
  "sanitize-text": "static-1.7844",
  "self-service-api": "static-1.9929",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1458",
  "signup-constants": "static-1.18218",
  "signup-ui-lego-core": "static-1.20228",
  "signup-ui-url-generator": "static-2.7736",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4477",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10701",
  "ui-addon-i18n": "static-1.10833",
  "ui-addon-react-router-dom": "static-1.9252",
  "ui-addon-upgrades": "static-9.17426",
  "ui-asset-management-lib": "static-1.10564",
  "ui-images": "static-2.1063",
  "UIComponents": "static-3.8076",
  "usage-tracker": "static-1.7041",
  "usage-tracker-container": "static-1.7031",
  "usage-tracker-core": "static-1.6891",
  "usage-tracker-public": "static-1.6852",
  "viral-links-lib": "static-1.6724",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven-hubspot": "static-1.5871",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3140",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2865",
  "quartz-webpack": "static-1.2812",
  "ai-components-ui-library": "static-1.8107",
  "amplitude-session-replay-browser": "static-1.53",
  "foundations-assets": "static-1.4536",
  "foundations-theming": "static-1.4107",
  "quartz-auth": "static-1.263",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4727",
  "foundations-theming-base": "static-1.3092",
  "HeadJS": "static-2.691",
  "framer-motion": "static-1.65",
  "hs-test-utils-bend-plugin": "static-1.2797",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.4036",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7629",
  "graphql": "static-1.75",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3372",
  "persist-promise": "static-1.3391",
  "reporting-client-types": "static-1.2355",
  "hs-story-utils": "static-1.9132",
  "react-flip-move": "static-1.63",
  "hub-http-shared-msw-handlers": "static-1.9224",
  "hubspotter-http": "static-1.4392",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6956",
  "crm-message-bus": "static-1.42116",
  "customer-data-filters-ui-msw-helpers": "static-1.20982",
  "customer-data-objects-ui-components": "static-1.12707",
  "customer-data-reference-ui-components": "static-1.12843",
  "customer-data-ui-utilities": "static-1.9531",
  "framework-builder-read-service-client": "static-1.3761",
  "framework-data-schema-quick-fetch": "static-1.6477",
  "framework-data-schema-resolvers": "static-1.6572",
  "inbound-db-properties-service-client": "static-1.3592",
  "multi-account-reference-resolvers": "static-1.671",
  "onboarding-tours": "static-1.16138",
  "reporting-datasets-permissions-lib": "static-1.12732",
  "ui-addon-teams": "static-1.21095",
  "apollo-stack-hubspot": "static-3.79",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67336",
  "customer-data-properties": "static-1.50504",
  "forms-ai-lib": "static-1.3851",
  "forms-utils-lib": "static-1.11990",
  "foundations-components-test-utils": "static-1.4803",
  "react-dnd-compat": "static-1.4329",
  "react-tinymce": "static-1.54370",
  "tinymce-config": "static-2.53496",
  "ui-gdpr-components": "static-1.10051",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3589",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.59",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.987",
  "ui-fonts": "static-1.391",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.771",
  "mobile-manifest-mixins": "static-1.464",
  "quartz-head": "static-1.253",
  "quartz-i18n": "static-1.263",
  "quartz-test": "static-1.263",
  "batch-promise": "static-1.1234",
  "external-options-client-types": "static-1.3896",
  "react-colorpicker": "static-2.9918",
  "copilot-toolkit": "static-1.10299",
  "data-quality-ui-library": "static-1.12110",
  "html-to-image": "static-1.47",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40443",
  "reporting-insights-lib": "static-1.899",
  "reporting-plugins": "static-1.9865",
  "ui-addon-draggable-compat": "static-2.3958",
  "ui-addon-opt": "static-4.8095",
  "ui-shepherd-react": "static-3.9849",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24468",
  "hubspot-apollo-client": "static-1.4585",
  "sales-templates-service-types-lib": "static-1.3907",
  "ui-business-units-lib": "static-1.8726",
  "merchandise-lib": "static-1.253",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5337",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3817",
  "upgrade-management-service-types": "static-1.4213",
  "timezone-utils": "static-2.4950",
  "bender-build-tools": "static-1.2823",
  "chatspot-core": "static-1.19979",
  "chirp-fetch": "static-1.1587",
  "bend-plugin-foundations-theming": "static-1.2590",
  "stylex": "static-1.25",
  "hubspotter-http-shared-msw-handlers": "static-1.9222",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3535",
  "crm-pipelines-api-client-types": "static-1.3878",
  "multi-currency-client-types": "static-1.3435",
  "getting-started-shared-tasks": "static-1.17614",
  "growth-data-modal": "static-1.5036",
  "growth-onboarding-confetti": "static-1.2756",
  "growth-onboarding-next-action-utils": "static-1.1200",
  "navigation-components": "static-1.16991",
  "onboarding-tours-client": "static-1.4352",
  "onboarding-tours-utils": "static-1.204",
  "ui-shepherd-tracker": "static-1.7230",
  "ui-universal-auth": "static-1.8565",
  "user-context": "static-1.4798",
  "cms-field-types": "static-1.4513",
  "content-icons-ui": "static-1.2118",
  "integrations-lib": "static-1.15107",
  "calling-global-api": "static-1.63338",
  "calling-internal-common": "static-1.30993",
  "calling-lifecycle-internal": "static-1.64720",
  "calling-lifecycle-messages": "static-1.57014",
  "commerce-products-lib": "static-1.8561",
  "crm-links": "static-1.5957",
  "file-manager-components": "static-1.22617",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.359",
  "inbounddb-objects-service-types": "static-1.3963",
  "meetings-icalendar-utils-lib": "static-1.339",
  "object-builder-ui-client": "static-1.47672",
  "pipeline-validation-client-types": "static-1.3699",
  "property-value-citations": "static-1.1118",
  "pulse": "static-1.195",
  "smart-property-lib": "static-1.5549",
  "tiered-pricing": "static-1.672",
  "ui-addon-iframeable": "static-1.8721",
  "final-form": "static-1.63",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19300",
  "tinymce-themes": "static-1.55466",
  "data-token-picker": "static-1.15898",
  "hub-http-contrib": "static-1.2752",
  "interframe": "static-3.4498",
  "tinymce-data": "static-1.39581",
  "tinymce-plugins": "static-1.56610",
  "ui-addon-sales-email": "static-1.4919",
  "magpie-lib": "static-1.5281",
  "magpie-types": "static-1.4741",
  "simple-logging-lib": "static-1.2756",
  "content-assistance-lib": "static-1.7312",
  "dashboard-lib": "static-1.80236",
  "ExportDialog": "static-6.10093",
  "hubspot-prosemirror": "static-1.17350",
  "hubspot-prosemirror-plugins": "static-1.17342",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8392",
  "campaign-roi-lib": "static-1.7999",
  "feedback-loader": "static-1.28687",
  "commerce-analytics-service-client": "static-1.3393",
  "onboarding-scopes": "static-1.6147",
  "apollo-link-hub-http": "static-2.4354",
  "hubspot-apollo-cache": "static-1.44",
  "growth-monetization-service-types": "static-1.4229",
  "nav-client-types": "static-1.2037",
  "purchase-motions-api": "static-1.5340",
  "trials-service-types": "static-1.3630",
  "chatspot-client-types": "static-1.10356",
  "idb-keyval": "static-1.37",
  "reactive-lib": "static-1.431",
  "getting-started-shared-tasks-store": "static-1.16732",
  "cohere-reconnect-lib": "static-1.60",
  "gemini-reconnect-lib": "static-1.18",
  "integrations-error-boundary-lib": "static-1.12522",
  "integrations-tracking-lib": "static-1.5289",
  "native-integrations-shared-strings": "static-1.7493",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10079",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.30999",
  "shared-worker-versioning": "static-1.10722",
  "calling-usage-tracker": "static-1.6244",
  "calling-orchestration-shared-library": "static-1.34520",
  "customer-data-tracking": "static-1.6566",
  "products-iframe-lib": "static-1.7090",
  "products-ui-components-shared-msw-handlers": "static-1.9606",
  "location-customization-utils-lib": "static-1.8253",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3862",
  "video-components-external": "static-1.10275",
  "video-data-lib": "static-1.33933",
  "directed-graph": "static-1.643",
  "event-emitter": "static-1.630",
  "breeze-intelligence-kit": "static-1.5178",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9307",
  "fsm": "static-1.3436",
  "policy-lib": "static-1.6507",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9370",
  "navigation-messaging": "static-1.6318",
  "FileManagerLib": "static-1.38257",
  "NamespacedHubStyle": "static-2.8812",
  "FileManagerCore": "static-1.38116",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11870",
  "layout-dnd-utils": "static-1.10845",
  "react-codemirror": "static-1.10308",
  "ui-addon-emoji-picker": "static-1.9595",
  "ui-brand-identity-lib": "static-1.13443",
  "ui-addon-video-player": "static-1.8426",
  "ui-coaching-tips": "static-1.27688",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8272",
  "payment-link-components": "static-1.22668",
  "EmailSignatureEditor": "static-1.23757",
  "eligibility-engine-service-types": "static-1.2911",
  "universal-page-editor-lib": "static-1.2702",
  "calling-orchestration-schema": "static-1.34745",
  "sales-views-client-types": "static-1.3998",
  "crm-record-cards-service-types": "static-1.3366",
  "content-media-composition-data-lib": "static-1.11063",
  "content-media-compositions": "static-2.15070",
  "media-bridge-lib": "static-1.18417",
  "trellis-story-utils": "static-1.4228",
  "storybook-react": "static-1.26",
  "audio-components": "static-1.5476",
  "FileManagerImages": "static-1.35768",
  "video-components": "static-1.12278",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4239",
  "video-embed": "static-1.34767",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67411",
  "layout-data-lib": "static-1.9170",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6291",
  "commerce-tours-lib": "static-1.5569",
  "growth-onboarding-reliability": "static-1.4792",
  "sales-checkout-service-client": "static-1.3405",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21138",
  "sales-email-signature-service-client": "static-1.3546",
  "hls.js": "static-1.32",
  "social-insights-client-types": "static-1.21121",
  "outpost": "static-1.3917",
  "advanced-menus-core": "static-1.14659",
  "advanced-menus-lib": "static-1.11650",
  "ui-memberships-settings-lib": "static-1.33174",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14658",
  "simple-menus-lib": "static-1.16175"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33756",
  "client-types": "/client-types/static-1.442",
  "documents-lib": "/documents-lib/static-1.33761",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1823",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4702",
  "highcharts": "/highcharts/static-8.97",
  "hs-promise-utils": "/hs-promise-utils/static-1.5295",
  "hs-test-utils": "/hs-test-utils/static-1.7686",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11129",
  "I18n": "/I18n/static-7.1542",
  "jasmine-immutable": "/jasmine-immutable/static-1.2721",
  "jasmine-runner": "/jasmine-runner/static-1.6157",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6588",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1.16336",
  "reporting-data": "/reporting-data/static-1.66117",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8050",
  "reporting-visualizations": "/reporting-visualizations/static-1.58193",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4450",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4777",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2169",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.699",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38548",
  "customer-data-objects": "/customer-data-objects/static-1.7317",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7775",
  "data-fetching-client": "/data-fetching-client/static-1.9380",
  "enviro": "/enviro/static-4.371",
  "FireAlarmUi": "/FireAlarmUi/static-1.4240",
  "flux-actions": "/flux-actions/static-1.298",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85021",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4436",
  "foundations-components": "/foundations-components/static-1.7320",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11437",
  "icons": "/icons/static-2.614",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6848",
  "metrics-js": "/metrics-js/static-1.9296",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "property-description-translator": "/property-description-translator/static-1.3564",
  "property-translator": "/property-translator/static-1.5118",
  "quartz-config": "/quartz-config/static-1.366",
  "quartz-core": "/quartz-core/static-1.5807",
  "quick-fetch": "/quick-fetch/static-1.3642",
  "raven": "/raven/static-3.5564",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5090",
  "react-virtualized": "/react-virtualized/static-2.92",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7865",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7796",
  "report-customization-components": "/report-customization-components/static-1.12241",
  "reporting-enablement": "/reporting-enablement/static-1.21768",
  "reporting-reports": "/reporting-reports/static-1.65795",
  "reporting-snowflake": "/reporting-snowflake/static-1.54735",
  "reporting-ui-components": "/reporting-ui-components/static-2.63389",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4308",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8639",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8751",
  "sanitize": "/sanitize/static-1.4180",
  "sanitize-text": "/sanitize-text/static-1.7844",
  "self-service-api": "/self-service-api/static-1.9929",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1458",
  "signup-constants": "/signup-constants/static-1.18218",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20228",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7736",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4477",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10701",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10833",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9252",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17426",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10564",
  "ui-images": "/ui-images/static-2.1063",
  "UIComponents": "/UIComponents/static-3.8076",
  "usage-tracker": "/usage-tracker/static-1.7041",
  "usage-tracker-container": "/usage-tracker-container/static-1.7031",
  "usage-tracker-core": "/usage-tracker-core/static-1.6891",
  "usage-tracker-public": "/usage-tracker-public/static-1.6852",
  "viral-links-lib": "/viral-links-lib/static-1.6724",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3140",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2865",
  "quartz-webpack": "/quartz-webpack/static-1.2812",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8107",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4536",
  "foundations-theming": "/foundations-theming/static-1.4107",
  "quartz-auth": "/quartz-auth/static-1.263",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4727",
  "foundations-theming-base": "/foundations-theming-base/static-1.3092",
  "HeadJS": "/HeadJS/static-2.691",
  "framer-motion": "/framer-motion/static-1.65",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2797",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.4036",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7629",
  "graphql": "/graphql/static-1.75",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3372",
  "persist-promise": "/persist-promise/static-1.3391",
  "reporting-client-types": "/reporting-client-types/static-1.2355",
  "hs-story-utils": "/hs-story-utils/static-1.9132",
  "react-flip-move": "/react-flip-move/static-1.63",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9224",
  "hubspotter-http": "/hubspotter-http/static-1.4392",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6956",
  "crm-message-bus": "/crm-message-bus/static-1.42116",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20982",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12707",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12843",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9531",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3761",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6477",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6572",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3592",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.671",
  "onboarding-tours": "/onboarding-tours/static-1.16138",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12732",
  "ui-addon-teams": "/ui-addon-teams/static-1.21095",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67336",
  "customer-data-properties": "/customer-data-properties/static-1.50504",
  "forms-ai-lib": "/forms-ai-lib/static-1.3851",
  "forms-utils-lib": "/forms-utils-lib/static-1.11990",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4803",
  "react-dnd-compat": "/react-dnd-compat/static-1.4329",
  "react-tinymce": "/react-tinymce/static-1.54370",
  "tinymce-config": "/tinymce-config/static-2.53496",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10051",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3589",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.59",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.987",
  "ui-fonts": "/ui-fonts/static-1.391",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.771",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.464",
  "quartz-head": "/quartz-head/static-1.253",
  "quartz-i18n": "/quartz-i18n/static-1.263",
  "quartz-test": "/quartz-test/static-1.263",
  "batch-promise": "/batch-promise/static-1.1234",
  "external-options-client-types": "/external-options-client-types/static-1.3896",
  "react-colorpicker": "/react-colorpicker/static-2.9918",
  "copilot-toolkit": "/copilot-toolkit/static-1.10299",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12110",
  "html-to-image": "/html-to-image/static-1.47",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40443",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.899",
  "reporting-plugins": "/reporting-plugins/static-1.9865",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3958",
  "ui-addon-opt": "/ui-addon-opt/static-4.8095",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9849",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24468",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4585",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3907",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8726",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5337",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3817",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4213",
  "timezone-utils": "/timezone-utils/static-2.4950",
  "bender-build-tools": "/bender-build-tools/static-1.2823",
  "chatspot-core": "/chatspot-core/static-1.19979",
  "chirp-fetch": "/chirp-fetch/static-1.1587",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2590",
  "stylex": "/stylex/static-1.25",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9222",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3535",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3878",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3435",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17614",
  "growth-data-modal": "/growth-data-modal/static-1.5036",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2756",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1200",
  "navigation-components": "/navigation-components/static-1.16991",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4352",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.204",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7230",
  "ui-universal-auth": "/ui-universal-auth/static-1.8565",
  "user-context": "/user-context/static-1.4798",
  "cms-field-types": "/cms-field-types/static-1.4513",
  "content-icons-ui": "/content-icons-ui/static-1.2118",
  "integrations-lib": "/integrations-lib/static-1.15107",
  "calling-global-api": "/calling-global-api/static-1.63338",
  "calling-internal-common": "/calling-internal-common/static-1.30993",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64720",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57014",
  "commerce-products-lib": "/commerce-products-lib/static-1.8561",
  "crm-links": "/crm-links/static-1.5957",
  "file-manager-components": "/file-manager-components/static-1.22617",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.359",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3963",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.339",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47672",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3699",
  "property-value-citations": "/property-value-citations/static-1.1118",
  "pulse": "/pulse/static-1.195",
  "smart-property-lib": "/smart-property-lib/static-1.5549",
  "tiered-pricing": "/tiered-pricing/static-1.672",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8721",
  "final-form": "/final-form/static-1.63",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19300",
  "tinymce-themes": "/tinymce-themes/static-1.55466",
  "data-token-picker": "/data-token-picker/static-1.15898",
  "hub-http-contrib": "/hub-http-contrib/static-1.2752",
  "interframe": "/interframe/static-3.4498",
  "tinymce-data": "/tinymce-data/static-1.39581",
  "tinymce-plugins": "/tinymce-plugins/static-1.56610",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4919",
  "magpie-lib": "/magpie-lib/static-1.5281",
  "magpie-types": "/magpie-types/static-1.4741",
  "simple-logging-lib": "/simple-logging-lib/static-1.2756",
  "content-assistance-lib": "/content-assistance-lib/static-1.7312",
  "dashboard-lib": "/dashboard-lib/static-1.80236",
  "ExportDialog": "/ExportDialog/static-6.10093",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17350",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17342",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8392",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.7999",
  "feedback-loader": "/feedback-loader/static-1.28687",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3393",
  "onboarding-scopes": "/onboarding-scopes/static-1.6147",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4354",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.44",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4229",
  "nav-client-types": "/nav-client-types/static-1.2037",
  "purchase-motions-api": "/purchase-motions-api/static-1.5340",
  "trials-service-types": "/trials-service-types/static-1.3630",
  "chatspot-client-types": "/chatspot-client-types/static-1.10356",
  "idb-keyval": "/idb-keyval/static-1.37",
  "reactive-lib": "/reactive-lib/static-1.431",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16732",
  "cohere-reconnect-lib": "/cohere-reconnect-lib/static-1.60",
  "gemini-reconnect-lib": "/gemini-reconnect-lib/static-1.18",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12522",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5289",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7493",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10079",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.30999",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10722",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6244",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34520",
  "customer-data-tracking": "/customer-data-tracking/static-1.6566",
  "products-iframe-lib": "/products-iframe-lib/static-1.7090",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9606",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8253",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3862",
  "video-components-external": "/video-components-external/static-1.10275",
  "video-data-lib": "/video-data-lib/static-1.33933",
  "directed-graph": "/directed-graph/static-1.643",
  "event-emitter": "/event-emitter/static-1.630",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5178",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9307",
  "fsm": "/fsm/static-1.3436",
  "policy-lib": "/policy-lib/static-1.6507",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9370",
  "navigation-messaging": "/navigation-messaging/static-1.6318",
  "FileManagerLib": "/FileManagerLib/static-1.38257",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8812",
  "FileManagerCore": "/FileManagerCore/static-1.38116",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11870",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10845",
  "react-codemirror": "/react-codemirror/static-1.10308",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9595",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13443",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8426",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27688",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8272",
  "payment-link-components": "/payment-link-components/static-1.22668",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23757",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2911",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2702",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34745",
  "sales-views-client-types": "/sales-views-client-types/static-1.3998",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3366",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11063",
  "content-media-compositions": "/content-media-compositions/static-2.15070",
  "media-bridge-lib": "/media-bridge-lib/static-1.18417",
  "trellis-story-utils": "/trellis-story-utils/static-1.4228",
  "storybook-react": "/storybook-react/static-1.26",
  "audio-components": "/audio-components/static-1.5476",
  "FileManagerImages": "/FileManagerImages/static-1.35768",
  "video-components": "/video-components/static-1.12278",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4239",
  "video-embed": "/video-embed/static-1.34767",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67411",
  "layout-data-lib": "/layout-data-lib/static-1.9170",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6291",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5569",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4792",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3405",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21138",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3546",
  "hls.js": "/hls.js/static-1.32",
  "social-insights-client-types": "/social-insights-client-types/static-1.21121",
  "outpost": "/outpost/static-1.3917",
  "advanced-menus-core": "/advanced-menus-core/static-1.14659",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11650",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33174",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14658",
  "simple-menus-lib": "/simple-menus-lib/static-1.16175"
}
};
